import { PackageIcon } from '@phosphor-icons/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/ui/icon'
import { Typography, TypographySizeKeys } from '@/components/ui/typography'
import { MarketShopOrderModel, PickUnion } from '@/models'

import * as S from './delivery-alert.styled'

export type DeliveryAlertProps = {
  order: MarketShopOrderModel
  size?: PickUnion<TypographySizeKeys, 'text-medium' | 'heading-medium'>
}

export const DeliveryAlert = ({ order, size = 'text-medium' }: DeliveryAlertProps) => {
  const { t } = useTranslation(['market-shop-restaurant'])
  const deliveryText =
    order.deliveryType === 'delivery'
      ? t('market-shop-restaurant:deliveryAlert.delivery')
      : t('market-shop-restaurant:deliveryAlert.pickup')

  const residentInfo = order.resident
    ? t('market-shop-restaurant:deliveryAlert.residentInfo', {
        apartment: order.resident.apartment,
        fullName: order.resident.fullName,
      })
    : ''

  return (
    <S.DeliveryAlert>
      <Icon icon={PackageIcon} size={size === 'text-medium' ? '2rem' : '2.4rem'} />
      <Typography as="span" size={size} weight="medium" breakLines={3}>
        {deliveryText} {residentInfo}
      </Typography>
    </S.DeliveryAlert>
  )
}
